module.exports = __webpack_public_path__ + "b7aae11a464c0de260ca52aef7cd3794.svg";